import { render, staticRenderFns } from "./BaseInfo.vue?vue&type=template&id=bd1eb88c&scoped=true&"
import script from "./BaseInfo.vue?vue&type=script&lang=ts&"
export * from "./BaseInfo.vue?vue&type=script&lang=ts&"
import style0 from "./BaseInfo.vue?vue&type=style&index=0&id=bd1eb88c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1eb88c",
  null
  
)

export default component.exports